import Swiper from "swiper";
import { A11y, Navigation } from "swiper/modules";
import "swiper/css";

const TESTIMONIALS_SELECTOR = ".wp-block-nomad-blocks-testimonials";

function initTestimonials() {
  document.querySelectorAll(TESTIMONIALS_SELECTOR).forEach((block) => {
    const carousel = block.querySelector(".wp-block-nomad-blocks-testimonials__items.swiper");

    if (!carousel || carousel.dataset.swiperInitialized === "true") {
      return;
    }

    carousel.dataset.swiperInitialized = "true";

    new Swiper(carousel, {
      modules: [A11y, Navigation],
      loop: true,
      slidesPerView: 1,
      spaceBetween: 24,
      navigation: {
        nextEl: block.querySelector(".swiper-button-next"),
        prevEl: block.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        900: {
          slidesPerView: 2,
          spaceBetween: 28,
        },
      },
    });
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initTestimonials);
} else {
  initTestimonials();
}
